export const HomeBg = [
  {
    chatStep: 0,
    bgImg: require('./assets/chat-bg/bg-yellow.jpg')
  },
  {
    chatStep: 3,
    bgImg: require('./assets/chat-bg/bg-blue.jpg')
  },
  {
    chatStep: 5,
    bgImg: require('./assets/chat-bg/bg-green.jpg')
  },
  {
    chatStep: 9,
    bgImg: require('./assets/chat-bg/bg-brown.jpg')
  },
  {
    chatStep: 13,
    bgImg: require('./assets/chat-bg/bg-blue.jpg')
  },
  {
    chatStep: 16,
    bgImg: require('./assets/chat-bg/bg-yellow.jpg')
  },
  {
    chatStep: 18,
    bgImg: require('./assets/chat-bg/bg-green.jpg')
  },
  {
    chatStep: 20,
    bgImg: require('./assets/chat-bg/bg-yellow.jpg')
  },
  {
    chatStep: 25,
    bgImg: require('./assets/chat-bg/bg-green.jpg')
  },
]